import React, { memo } from 'react'
import { IVin } from 'types/carrier'
import { useFeatureFlag } from 'utils/context/FeatureFlagsContext'
import { DeleteSingleVin } from './DeleteSingleVin'
import { SingleVin } from './SingleVin'

interface IVinGridProps {
  vins: IVin[]
  deleteVin?: (vin: IVin) => void
}

export const VinGrid = memo<IVinGridProps>(({ deleteVin, vins }) => {
  const isHighwayMilestoneFourComplianceTabEnabled = useFeatureFlag(
    'highwayMilestoneFourComplianceTab'
  )
  const currentVins = vins.filter(vin => !vin._destroy)
  return (
    <>
      {currentVins && currentVins.length ? (
        <div className='grid-col-xs-4' data-test='vin-grid'>
          {currentVins.map(vin => {
            return isHighwayMilestoneFourComplianceTabEnabled ? (
              <DeleteSingleVin key={vin.vin} vin={vin} deleteVin={deleteVin} />
            ) : (
              <SingleVin key={vin.vin} vin={vin} deleteVin={deleteVin} />
            )
          })}
        </div>
      ) : (
        <p>There are no VINs entered for this carrier yet.</p>
      )}
    </>
  )
})
